import { useEffect, useState } from "react";
import { LogOut, LayoutDashboard, Users2, ListChecks, Clock4, BookUser, Truck, AlertTriangle, FileText, ScanLine } from "lucide-react";
import { api } from "@/lib/api";
import { useEventContent } from "@/context/EventContentContext";
import StaffDashboard from "./staff/StaffDashboard";
import StaffCommittees from "./staff/StaffCommittees";
import StaffChecklist from "./staff/StaffChecklist";
import StaffRunOfShow from "./staff/StaffRunOfShow";
import StaffContacts from "./staff/StaffContacts";
import StaffSuppliers from "./staff/StaffSuppliers";
import StaffIncidents from "./staff/StaffIncidents";
import StaffDocuments from "./staff/StaffDocuments";
import StaffTickets from "./staff/StaffTickets";

const TABS = [
  { id: "dashboard", label: "Dashboard", icon: LayoutDashboard, Comp: StaffDashboard },
  { id: "committees", label: "Comités", icon: Users2, Comp: StaffCommittees },
  { id: "checklist", label: "Checklist", icon: ListChecks, Comp: StaffChecklist },
  { id: "ros", label: "Run of Show", icon: Clock4, Comp: StaffRunOfShow },
  { id: "contacts", label: "Contactos", icon: BookUser, Comp: StaffContacts },
  { id: "suppliers", label: "Proveedores", icon: Truck, Comp: StaffSuppliers },
  { id: "incidents", label: "Incidencias", icon: AlertTriangle, Comp: StaffIncidents },
  { id: "documents", label: "Documentos", icon: FileText, Comp: StaffDocuments },
  { id: "tickets", label: "Accesos QR", icon: ScanLine, Comp: StaffTickets },
];

export default function StaffPortal({ onLogout }) {
  const { event } = useEventContent();
  const [active, setActive] = useState("dashboard");
  const [counts, setCounts] = useState({ committees: 0, checklist: 0, incidents: 0 });

  useEffect(() => {
    Promise.all([
      api.get("/committees"),
      api.get("/checklist"),
      api.get("/incidents"),
    ]).then(([c, ch, inc]) =>
      setCounts({ committees: c.data.length, checklist: ch.data.length, incidents: inc.data.length })
    ).catch(() => {});
  }, []);

  const Active = TABS.find((t) => t.id === active)?.Comp || StaffDashboard;

  return (
    <div data-testid="staff-portal" className="bg-[var(--brand-bg)]">
      {/* Staff sub-header */}
      <div className="border-b border-[var(--brand-border)] bg-white">
        <div className="container-cg py-5 flex flex-wrap items-center justify-between gap-3">
          <div>
            <div className="overline text-[var(--brand-primary)]">Portal del Staff</div>
            <h1 className="font-serif-cg text-2xl md:text-3xl tracking-tight">Centro de operaciones</h1>
          </div>
          <div className="flex items-center gap-3">
            <span className="hidden md:inline text-xs text-[var(--brand-muted)]">
              {event.date} · {event.venue}
            </span>
            <button data-testid="staff-logout" onClick={onLogout} className="btn-secondary-cg">
              <LogOut size={14} /> Salir
            </button>
          </div>
        </div>

        {/* Tab bar */}
        <div className="container-cg overflow-x-auto">
          <div className="flex gap-1 md:gap-2 pb-3 min-w-max">
            {TABS.map((t) => {
              const Icon = t.icon;
              const isActive = active === t.id;
              return (
                <button
                  key={t.id}
                  data-testid={`staff-tab-${t.id}`}
                  onClick={() => setActive(t.id)}
                  className={`flex items-center gap-2 px-4 py-2.5 text-xs uppercase tracking-wider border transition-colors ${
                    isActive
                      ? "bg-[var(--brand-primary)] text-white border-[var(--brand-primary)]"
                      : "bg-white text-[var(--brand-ink)] border-[var(--brand-border)] hover:border-[var(--brand-primary)]"
                  }`}
                >
                  <Icon size={14} /> {t.label}
                </button>
              );
            })}
          </div>
        </div>
      </div>

      <div className="container-cg py-10">
        <Active counts={counts} />
      </div>
    </div>
  );
}
